<template>
  <div :class="['web-004-nav', isMobile && 'mobile-view']">
    <img
      v-if="websiteMsg.logo"
      class="logo"
      :src="websiteMsg.logo"
      alt=""
    >
    <div v-else />
    <el-menu
      ref="elMenu"
      :default-active="activeIndex"
      mode="horizontal"
    >
      <template v-for="(item,index) in menu">
        <el-menu-item
          :key="index"
          :index="index + ''"
          @click.native="onClick(item, index)"
        >
          {{ item.name }}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import api from '../../proxy';
import { openUrl } from '../../../../../lib/utils';

export default {
    name: 'Navigation',
    props: {
        websiteMsg: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        return {
            activeIndex: '0',
            menu: [{
                id: '0',
                catalogId: '0',
                name: '首页',
            }],
        };
    },
    computed: {
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
    },
    async created () {
        const query = this.$route.query;
        this.activeIndex = query.activeIndex || '0';
        if (query.siteId) {
            this.websiteMsg.id = query.siteId;
        }
        const param = {
            siteId: this.websiteMsg.id,
        };
        const res = await api.getNavigation(param);
        if (res.errcode === 0) {
            const catalogList = res.data || [];
            this.setTreeNode(catalogList, this.menu, 1);
            this.$store.commit('system/mu_flatTreeList', this.menu);
            // const currCatalog = catalogList.find(itm => itm.catalogId + '' === query.rootId);
        } else {
            this.$message.error(res.errmsg);
        }
    },
    methods: {
        onClick (item, index) {
            console.log('onClick', item);
            const query = this.$route.query;
            let path = '';
            let routeUrl = '';
            if (index === 0) {
                path = '/web004/home';
                routeUrl = this.$router.resolve({
                    path,
                    query: { activeIndex: index + '', siteId: query.siteId, preview: query.preview },
                });
            } else {
                switch (index) {
                    case 1:
                        path = '/web004/anoahPlatform';
                        break;
                    case 2:
                        path = '/web004/AISuperviseSystem';
                        break;
                    case 3:
                        path = '/web004/contactUs';
                        break;
                }
                routeUrl = this.$router.resolve({
                    path,
                    query: {
                        activeIndex: index + '',
                        siteId: query.siteId,
                        catalogId: item.catalogId,
                        preview: query.preview,
                    },
                });
            }
            if (routeUrl) {
                if (!this.isMobile) {
                    openUrl(routeUrl.href);
                } else {
                    this.$router.replace({
                        path,
                        query: {
                            activeIndex: index + '',
                            siteId: query.siteId,
                            catalogId: item.catalogId,
                            preview: query.preview,
                        },
                    });
                    this.activeIndex = index + '';
                }
            }
            this.$nextTick(() => {
                this.$refs.elMenu.activeIndex = this.activeIndex;
            });
        },
        setTreeNode (catalogList, menu, layer, parentId) {
            for (const item of catalogList) {
                const currentItem = {
                    name: item.name.replace(/\u200B/g, ''),
                    catalogId: item.catalogId + '',
                    id: item.id + '',
                    rotation: item.rotation,
                };
                // if (layer === 1 && currentItem.name.length > 5) {
                //     currentItem.name = currentItem.name.substr(0, 4) + '…';
                // }
                // if (parentId) currentItem.parentId = parentId + '';
                // // 导航最多显示2层
                // if (item.child && item.child.length && layer < 2) {
                //     currentItem.child = [];
                //     this.setTreeNode(item.child, currentItem.child, layer + 1, item.catalogId);
                // }
                menu.push(currentItem);
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.web-004-nav {
    height: 60px;
    width: 100%;
    min-width: $pageWidth;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-left: 16%;
    padding-right: 13%;
    user-select: none;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    .logo {
        max-width: 170px;
        max-height: 24px;
    }
    ::v-deep .el-menu.el-menu--horizontal {
        border-bottom: unset;
        display: flex;
    }
    ::v-deep .el-menu-item {
        font-size: 16px;
        color: #141414;
        padding: 0;
        padding-right: 2px;
        margin: 0 45px;
    }
    ::v-deep .el-submenu {
        .el-submenu__title {
            font-size: 16px;
            color: #141414;
        }
    }
    ::v-deep .el-menu--horizontal>.el-menu-item {
        height: 38px;
        line-height: 38px;
    }
    ::v-deep .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 3px solid;
        border-image: linear-gradient( 90deg, #FF9400 0%, #FFD300 100%) 1;
        color: #FFA600;
        font-weight: 600;
    }
    ::v-deep .el-menu--horizontal>.el-submenu.is-active {
        .el-submenu__title {
            border-bottom: 2px solid #2873E9 !important;
            color: #2873E9 !important;
        }
    }
    ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: 2px solid #2873E9;
        color: #2873E9;
    }
    &.mobile-view {
        height: 40px;
        min-width: unset;
        padding-left: 10px;
        padding-right: 10px;
        .logo {
            max-width: 70px;
            max-height: 12px;
        }
        ::v-deep .el-menu-item {
            font-size: 12px;
            color: #141414;
            padding: 0;
            margin: 0 8px;
        }
        ::v-deep .el-submenu {
            .el-submenu__title {
                font-size: 12px;
                color: #141414;
            }
        }
        ::v-deep .el-menu--horizontal>.el-menu-item {
            height: 28px;
            line-height: 28px;
        }
        ::v-deep .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 2px solid;
            border-image: linear-gradient( 90deg, #FF9400 0%, #FFD300 100%) 1;
            color: #FFA600;
            font-weight: 600;
        }
        ::v-deep .el-menu--horizontal>.el-submenu.is-active {
            .el-submenu__title {
                border-bottom: 2px solid #2873E9 !important;
                color: #2873E9 !important;
            }
        }
        ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
            border-bottom: 2px solid #2873E9;
            color: #2873E9;
        }
    }
}
</style>
